import { render, staticRenderFns } from "./WorkTaskAuditForm.vue?vue&type=template&id=06f4b599"
import script from "./WorkTaskAuditForm.vue?vue&type=script&lang=ts"
export * from "./WorkTaskAuditForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports